<template>
  <gj-virtual-select-more
    v-bind="$attrs"
    v-on="$listeners"
    v-model="chargerList"
    :list="active ? activeUserOptions : userOptions"
    type="multi-check"
    width="160px"
    :multiple="true"
  >
  </gj-virtual-select-more>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'gj-charger-select',
  props: {
    value: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chargerList: this.value,
    };
  },

  computed: {
    ...mapGetters({
      activeUserOptions: 'activeUserOptions',
      userOptions: 'userOptions',
    }),
  },
  watch: {
    value(val) {
      this.chargerList = val || [];
    },
    chargerList(val) {
      this.$emit('input', val || []);
    },
  },
};
</script>

<style scoped>
</style>
